export const getElement = (selector) => !!document ? document.getElementById(selector) || document.querySelector(selector) : null;
export const getElementsByClassName = (selector) => !!document ? document.getElementsByClassName(selector) : null;
export const getFirstElementByClassName = (selector) => {
    if (!!document) {
        const elements = document.getElementsByClassName(selector);
        return elements.length ? elements[0] : null;
    }
    return null;
};
export const isElementOverflowed = (el) => el.clientWidth < el.scrollWidth;
//# sourceMappingURL=DocumentUtils.js.map